<template>
  <div class="app-modal-wrap alt">
    <vodal
      :show="payments.showPaymentsReceivedModal"
      :height="400"
      :width="360"
      animation="zoom"
      :closeOnClickMask="false"
      :closeButton="false"
    >
      <div class="app-modal alt">
        <NoPaymentReceivedCard
          v-if="payments.paymentStatus === 'not-received'"
        />
        <PaymentReceivedCard v-if="payments.paymentStatus === 'received'" />
      </div>
    </vodal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import NoPaymentReceivedCard from "../Cards/NoPaymentReceivedCard";
import PaymentReceivedCard from "../Cards/PaymentReceivedCard";

export default {
  name: "PaymentReceivedModal",
  components: { NoPaymentReceivedCard, PaymentReceivedCard },
  data() {
    return {
      show: false
    };
  },
  computed: {
    ...mapState(["payments"])
  },
  methods: {
    openModal() {
      this.show = true;
    },
    closeModal() {
      this.show = false;
    }
  }
};
</script>

<style scoped></style>
